import * as React from "react";
export function SvgWarningHighSeverity(
  props: React.SVGProps<SVGSVGElement>
): JSX.Element {
  return (
    <svg baseProfile="tiny" width={15} height={15} {...props}>
      <path
        fill="#FECA63"
        d="M1.1 12L6.8 1.8c.3-.6 1-.6 1.4 0L13.9 12c.3.6-.1 1.3-.8 1.3H1.9c-.6 0-1.1-.7-.8-1.3z"
      />
      <path fill="#333" d="M6.7 10.1h1.6v1.6H6.7zM6.7 4.5h1.6v4.8H6.7z" />
    </svg>
  );
}
